import React from 'react';
import {
    Page,
    Card,
    Button,
    Layout,
} from '@shopify/polaris';
import { Helmet } from 'react-helmet';
import { apiFetch as fetch } from '../common/Helpers';
import { AppContext } from '../common/AppContext';

class ChangePlanFreePage extends React.Component {

    state = {
        storeInfo: {}
    };

    render() {

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Switch To Free Plan</title>
                </Helmet>
                <Page title="Temporarily Switch To Free Plan">
                    <Layout>
                        <Layout.Section>
                            <Card>
                                <Button primary={true} onClick={() => this.handleSubscribe("FreeTemp")}>Switch To Free</Button>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div >
        );
    }

    handleSubscribe(planName) {
        fetch(`api/storeConnections/changePlanRequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "planTier": planName,
                "skipTrial": true
            })
        }).then(response => response.json())
            .then((data) => {

                if (data.confirmationUrl != null) {
                    window.location.href = data.confirmationUrl;
                }
            });
    }

    componentDidMount() {
    }
}

ChangePlanFreePage.contextType = AppContext;

export default ChangePlanFreePage;